import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import appInfo from "utility/app-info";

// Encode appInfo for URL parameters
const encodedAppInfo = encodeURIComponent(JSON.stringify(appInfo));
const userId = localStorage.getItem("userID");

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_UPLOAD_URL}`,
  }),
  reducerPath: "woneApi",
  tagTypes: ["Media"],
  endpoints: (build) => ({
    //MEDIA
    uploadCSV: build.mutation({
      query: ({ id, body }) => ({
        url: `companies/upload_members_csv/${id}?app_info=${encodedAppInfo}&userId=${userId}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Media"],
    }),
  }),
});

export const {
  //CSV
  useUploadCSVMutation,
} = api;
